import React, { Component } from "react";
import { CircularProgress, Box } from "@mui/material";
import performRequest from "../../../network/perform-request";
import { competitionsShowRoute } from "../../../network/api-routes";
import EditCompetitionForm from "./EditCompetitionForm";
import { competitionAdminRoutesFromMatch } from "constants/competition-admin-routes";
class EditCompetition extends Component {
  constructor(props) {
    super();

    this.state = {
      id: props.match.params.id,
      ready: false,
      competition: null,
    };
  }

  componentDidMount() {
    this.fetch(this.props.userContext.user);
  }

  fetch(user) {
    performRequest("POST", competitionsShowRoute, { competition_uuid: this.state.id }, true, user)
      .then((response) => {
        this.setState({
          competition: response.data.data,
          ready: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSubmitResponse(competition) {
    if (this.props.onSaved) {
      this.props.onSaved(competition);
      return;
    }
    const routes = competitionAdminRoutesFromMatch(this.props.match);
    this.props.history.push(routes.overview);
  }

  render() {
    return (
      <Box sx={{ width: "100%" }}>
        {!this.state.ready && <CircularProgress />}
        {this.state.ready && this.state.competition && (
          <EditCompetitionForm
            competition={this.state.competition}
            hideDates={this.props.hideCompetitionDates}
            hideTitle={this.props.hideCompetitionDates}
            gestion={Boolean(this.props.gestion)}
            onSubmitResponse={this.onSubmitResponse.bind(this)}
          />
        )}
      </Box>
    );
  }
}

export default EditCompetition;
